<template>
  <nav>
    <v-row
      class="fill-height loginBackground"
      align="center"
    >
      <v-col
        v-if="googleCallback"
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <v-progress-circular
          :size="125"
          :width="7"
          indeterminate
          class="my-16"
          color="accent"
        />
      </v-col>
      <v-col
        v-if="!loadingData && !googleCallback"
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <v-alert
          v-if="verificationMsg != '' && !showAlertInsideForm"
          type="success"
          class="rounded-xxl mb-8 text-left"
          max-width="600"
        >
          {{ $t(verificationMsg) }}
        </v-alert>
        <v-alert
          v-if="deletedAccountMsg != '' && !showAlertInsideForm"
          type="success"
          class="rounded-xxl mb-8 text-left"
          max-width="600"
        >
          {{ $t(deletedAccountMsg) }}
        </v-alert>
        <v-alert
          v-if="verificationMsgToken != '' && tokeninvalid == true && !showAlertInsideForm"
          type="success"
          class="rounded-xxl mb-8 text-left"
          max-width="600"
        >
          {{ $t(verificationMsgToken) }}
        </v-alert>
        <v-alert
          v-if="verificationMsgToken != '' && tokeninvalid == false && !showAlertInsideForm"
          type="error"
          class="rounded-xxl mb-8 text-left"
          max-width="600"
        >
          {{ $t(verificationMsgToken) }}
        </v-alert>
        <v-alert
          v-if="alertType == 'success' && verifiedfogotenpass == true && !showAlertInsideForm"
          type="success"
          class="rounded-xxl mb-8 text-left"
          max-width="600"
        >
          {{ $t(alertMsg) }}
        </v-alert>
        <v-alert
          v-if="alertType == 'error' && verifiedfogotenpass == false && !showAlertInsideForm"
          type="error"
          class="rounded-xxl mb-8 text-left"
          max-width="600"
        >
          {{ $t(alertMsg) }}
        </v-alert>
        <v-card
          max-width="600"
          elevation="0"
          rounded="xxl"
          color="background"
        >
          <LanguageSwitcher @languageSelected = "updateLocale"/>
          <div class="d-inline-block pt-6">
            <v-img
              contain
              src="../../assets/rtplogo.svg"
              max-width="200"
              class="mx-auto"
            />
          </div>
          <v-card-title class="text-h5 font-weight-bold text-center justify-center px-6 no-break">
            {{ $t('loginTitle') }}
          </v-card-title>
                          
          <v-card-actions class="px-6">
            <GoogleButton data-testid="google-button"/>
          </v-card-actions>
          <v-row align="center" no-gutters class="ma-8">              
            <v-divider class="text-divider"></v-divider><span class="px-3 greytext--text">{{ $t('or')}}</span><v-divider class="text-divider"></v-divider>
          </v-row>
          <v-card-subtitle class="text-body-2 pt-4 px-6 no-break">
            {{ $t('loginSubTitle') }}
          </v-card-subtitle>
          <v-card-text class="px-6">
            <v-alert
              v-if="alertType == 'error' && verified == true && verifiedfogotenpass == true && showAlertInsideForm"
              type="error"
              class="rounded-xxl text-left"
            >
              {{ $t(alertMsg) }}
            </v-alert>
            <v-alert
              v-if="alertType == 'error' && verified == false && showAlertInsideForm"
              type="error"
              class="rounded-xxl text-left"
            >
              {{ $t(alertMsg) }}
              <router-link
                data-testid="resend-link"
                to="#"
                class="white--text"
                @click.native="resendConfirmationLink"
              >
                {{ $t('resendVerificationLink') }}
              </router-link>
              <v-progress-circular
                v-if="isLoading"
                size="20"
                indeterminate
                class="mx-2"
              />
            </v-alert>
            <v-alert
              v-if="alertType == 'success' && verified == false && showAlertInsideForm"
              type="success"
              class="rounded-xxl text-left"
            >
              {{ $t(alertMsg) }}
            </v-alert>
            <v-form
              ref="form"
              v-model="valid"
              @keyup.enter="login"
              @submit.prevent
            >
              <v-text-field
                v-model="email"
                data-testid="email-input"
                solo
                hide-details="auto"
                elevation="6"
                class="rounded-xxl text-body-2"
                :placeholder="$t('loginEmailPlaceholder')"
                :rules="emailRules"
                @keyup.enter="focusNext($event.target)"
              />
              <v-text-field
                v-model="password"
                data-testid="password-input"
                solo
                hide-details="auto"
                class="rounded-xxl text-body-2"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                :placeholder="$t('loginPasswordPlaceholder')"
                :rules="passwordRules"
                @keyup.enter="focusNext($event.target)"
                @click:append="showPassword = !showPassword"
              />
              <v-card-actions class="px-0">
                <v-btn
                  data-testid="submit-button"
                  type="submit"
                  :disabled="buttonDisabled"
                  color="accent"
                  large
                  block
                  class="rounded-xxl text-none"
                  @click="login"
                >
                  {{ $t('signIn') }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
          <v-card-actions class="pa-6">
            <v-spacer />
            <v-btn
              data-testid="forgotten-pass-dialog-button"
              class="forgottenpass text-decoration-none text-none text-body-2 darktext--text"
              elevation="0"
              @click.stop="
                dialogVisible=true, 
                forgottenPassDialogTitle=$t('forgottenPassDialogTitle'), 
                forgottenPassDialogText=$t('forgottenPassDialogText'),
                forgottenPassDialogSubmitBtn=$t('send')
                forgottenPassDialogCancelBtn=$t('back')"
            >
              {{ $t('loginResetPasswordLink') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <ForgottenPassDialog
      :visible="dialogVisible" 
      :cd-title="forgottenPassDialogTitle" 
      :cd-text="forgottenPassDialogText" 
      :cd-submit-btn="forgottenPassDialogSubmitBtn" 
      :cd-cancel-btn="forgottenPassDialogCancelBtn" 
      @close="dialogVisible=false" 
      @proceedSend="proceedSend"
    />
  </nav>
</template>
<script>
import { ruleRequired } from '../../rules/formRules.js';
import i18n from '../../plugins/i18n'
import {loginAuth} from '../../auth/auth.js'
import { loginUser, resendEmail, getUserFromGoogle } from '../../api/userApi'
import ForgottenPassDialog from '../../components/ForgottenPassDialog';
import LanguageSwitcher from '../../components/LanguageSwitcher'
import GoogleButton from '../../components/GoogleButton'

export default {
    components: {
        ForgottenPassDialog,
        LanguageSwitcher,
        GoogleButton
    },
    data(){
        return{
            valid: true,
            email: '',
            password: '',
            showPassword: false,
            alertType: '',
            alertMsg: '',
            showAlertInsideForm: false,
            buttonDisabled: false,
            showVerificationMsg: false,
            verificationMsg: '',
            deletedAccountMsg:'',
            verificationMsgToken :'',
            token: '',
            verified: true,
            verifiedfogotenpass: true,
            isLoading: false,
            dialogVisible: false,
            forgottenPassDialogTitle: '',
            forgottenPassDialogText: '',
            forgottenPassDialogCancelBtn: '',
            forgottenPassDialogSubmitBtn: '',
            tokeninvalid: true,
            space: window.location.host.split('.')[0],
            referer: null,
            focusNext(elem) {
                const currentIndex = Array.from(elem.form.elements).indexOf(elem);
                elem.form.elements.item(
                    currentIndex < elem.form.elements.length - 1 ?
                    currentIndex + 1 :
                    0
                ).focus();
            },
            googleCallback: false,
            loadingData: false,
            languageRuleActive: true
         }
    },
    computed: {
        emailRules() {
            return this.languageRuleActive ? ruleRequired('labelEmail') : []
        },
        passwordRules() {
            return this.languageRuleActive ? ruleRequired('labelPassword') : []
        }
    },
    async created() {
        this.loadingData = true
        function checkCookie(name) {
            var dc = document.cookie;
            var prefix = name + "=";
            var begin = dc.indexOf("; " + prefix);
            if (begin == -1) {
                begin = dc.indexOf(prefix);
                if (begin != 0) return null;
            }
        }

        checkCookie('id') && window.$cookies.remove("id", null, process.env.VUE_APP_DOMAIN)
        checkCookie('token') && window.$cookies.remove("token", null, process.env.VUE_APP_DOMAIN)
        localStorage.clear()

        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        let referer = urlParams.get('referer')
        if (referer) {
            this.referer = referer;
        }

        let gCallBack1 = urlParams.get('state')
        let gCallBack2 = urlParams.get('code')
        if(gCallBack1 && gCallBack2){
          this.googleCallback = true
          await this.getUserFromGoogle(queryString)
        }

        if(this.$route.params.successfullyDeletedAccount){      
             this.deletedAccountMsg  = 'successfullyDeletedAccount';
        }
        if(this.$route.params.verifiedEmail){
            this.verificationMsg = 'confirmAccountSucess'
        }
        if(this.$route.params.alreadyVerifiedEmail){
            this.verificationMsg = 'confirmAccountErrorAlreadyVerified'
        }
        if(this.$route.params.passwordReset ==  true){
            this.tokeninvalid = true
            this.verificationMsgToken  = 'updatedNewPassword'
        }else if(this.$route.params.passwordReset == false){
            this.tokeninvalid = false
            this.verificationMsgToken  = 'serverError'
        }
        this.loadingData = false
        
    },
     
    methods: {
        proceedSend(msg, type){
            if(type == 'success'){
                this.isLoading = true
                this.verifiedfogotenpass = true
                this.dialogVisible = false
                this.alertType= type
                this.alertMsg = msg
            }
            if(type == 'error'){
                this.isLoading = true
                this.verifiedfogotenpass = false
                this.dialogVisible = false
                this.alertType= type
                this.alertMsg = msg
            }
            this.showAlertInsideForm = false
            this.isLoading = false
        },

        async login(){
            this.verified = true
            this.$refs.form.validate()
            if(this.valid){
                this.buttonDisabled = true
                try {
                    let data = {
                        email: this.email.trim(),
                        password: this.password.trim()
                    };
                    const response = await loginUser(data)
                    if(response.status == 200) {
                        //this.$router.push({path: '/profile'})
                        loginAuth(response.data.meta.access_token, response.data.data)

                        i18n.locale = response.data.data.attributes.language && response.data.data.attributes.language.trim()
                        window.$cookies.set("language", i18n.locale, 0, null, process.env.VUE_APP_DOMAIN)
                        if (this.$route.query.referer) {
                            window.location.href = process.env.VUE_APP_PROTOCOL + "://" + this.$route.query.referer;
                        } else {
                            this.$router.push(this.$route.query.redirect || '/spaces')
                        }  

                    }
                    this.$refs.form.reset()
                } catch (e) {
                    this.alertType = 'error'
                    if(e.response){
                        if(e.response.status == 401){
                            this.alertMsg = 'loginErrorWrongCredentials'
                        }
                        else if(e.response.status == 403){
                            for (let i = 0; i < e.response.data.errors.length; i++) {
                                if (e.response.data.errors[i].detail == 'You must log in using SSO') {
                                    this.alertType = 'error'
                                    this.alertMsg = 'mustLogInUsingSSO'
                                } else {
                                    this.alertMsg = 'loginErrorEmailNotVerified'
                                    this.verified = false
                                    this.token = e.response.data.errors[0].meta.access_token;
                                }
                            }
                        }
                        else {
                            this.alertMsg =  'serverError'
                        }
                        this.showAlertInsideForm = true
                    }
                }
                this.buttonDisabled = false
            }
        },
        async resendConfirmationLink(){
            this.isLoading = true
            try {
                const response = await resendEmail(this.token)
                if(response.status == 200) {
                    this.verified = false
                    this.alertType = 'success'
                    this.alertMsg =  'verificationLinkSent'
                    this.isLoading = false
                }
            } catch (e){
                this.alertType = 'error'
                this.alertMsg =  'serverError'
                this.isLoading = false
            }

            this.showAlertInsideForm = true
        },
        async getUserFromGoogle(queryString){
            try {
                let language = window.$cookies.get('language') ? window.$cookies.get('language') : "en"
                queryString = queryString + '&language=' + language
                const response = await getUserFromGoogle(queryString)
                if(response.status == 200) {
                    if(response.data.meta.show_steps == true){
                        if (window.$cookies.get("google_referer").page == 'RegistrationGettingStarted') {
                            this.$router.push({name: 'RegistrationGettingStarted', params: {loginToken: response.data.meta.access_token}})
                            window.$cookies.remove("google_referer")
                            window.$cookies.remove("google_referer", null, process.env.VUE_APP_DOMAIN);
                        }else{
                            this.$router.push({name: 'AcceptGDPR', params: {loginToken: response.data.meta.access_token}})
                        }
                    }else{
                        //make the login using the access token
                        loginAuth(response.data.meta.access_token, response.data.data)
                        i18n.locale = response.data.data.attributes.language && response.data.data.attributes.language.trim()
                        window.$cookies.set("language", i18n.locale, 0, null, process.env.VUE_APP_DOMAIN)
                        
                        if (window.$cookies.isKey("google_referer")) {
                            window.location.href = window.$cookies.get("google_referer").redirect
                            window.$cookies.remove("google_referer")
                            window.$cookies.remove("google_referer", null, process.env.VUE_APP_DOMAIN);
                        }else{
                            this.$router.push('/spaces')
                        }
                    }
                }
                if(response.status == 201) {
                    //newly created user
                    if (window.$cookies.get("google_referer").page == 'RegistrationGettingStarted') {
                        this.$router.push({name: 'RegistrationGettingStarted', params: {loginToken: response.data.meta.access_token}})
                        window.$cookies.remove("google_referer")
                        window.$cookies.remove("google_referer", null, process.env.VUE_APP_DOMAIN);
                    }else{
                        this.$router.push({name: 'AcceptGDPR', params: {loginToken: response.data.meta.access_token}})
                    }
                }
            } catch (e){
                if(e.response){
                    if (e.response.status == 403){
                        for (let i = 0; i < e.response.data.errors.length; i++) {
                            if (e.response.data.errors[i].detail == 'You must log in using SSO') {
                                if(window.$cookies.isKey("google_referer")) {
                                    if(window.$cookies.get("google_referer").space == 'id'){
                                        this.googleCallback = false
                                        this.alertType = 'error'
                                        this.alertMsg = 'mustLogInUsingSSO'
                                        window.$cookies.remove("google_referer")
                                        window.$cookies.remove("google_referer", null, process.env.VUE_APP_DOMAIN);
                                    }else{
                                        window.$cookies.set("show_sso_error", true, 0, null, process.env.VUE_APP_DOMAIN);
                                        window.location.href = process.env.VUE_APP_PROTOCOL + "://" + window.$cookies.get("google_referer").space + "." + process.env.VUE_APP_DOMAIN + "/login"
                                        window.$cookies.remove("google_referer")
                                        window.$cookies.remove("google_referer", null, process.env.VUE_APP_DOMAIN);
                                    }
                                }else {
                                    this.googleCallback = false
                                    this.alertType = 'error'
                                    this.alertMsg = 'mustLogInUsingSSO'
                                }
                            }
                        }
                    } else {
                        this.googleCallback = false
                        this.alertType = 'error'
                        this.alertMsg =  'serverError'
                    }
                }
            }
            this.showAlertInsideForm = true
        },
        updateLocale() {
            this.languageRuleActive = false
            this.$nextTick(() => {
              this.languageRuleActive = true
            })
        },
    }
}

</script>
<style>
.forgottenpass.v-btn--contained,
.forgottenpass.v-btn--contained:active{
    box-shadow: none;
}
.forgottenpass.v-btn:not(.v-btn--text):not(.v-btn--outlined):hover:before,
.forgottenpass.v-btn:not(.v-btn--text):not(.v-btn--outlined):focus:before{
    opacity: 0;
}
</style>